const prolog =
    '…Вначале была книга. Ее в 2021 году написали норильские студенты Медиашколы в Заполярье, большинство из которых город свой собирались покинуть\u00A0– уехать учиться на материк. Но рассказали о том, какую частичку Норильска они навсегда увозят в своем сердце. Ведь он может быть таким разным, и у каждого он\u00A0– свой. А теперь мы решили эту книжку оцифровать и подарить всем! Даже тем, кто там ни разу не был…';

export default prolog;
